<template>
  <Select :value="value" @input="handleInput" :label="label" :options="options" :isVerific="false" :placeholder="placeholder" :startVerific="false" />
</template>
<script>
import Select from '../Select/select.vue';
import { Api, Codes } from 'api';
export default {
  name: 'Country',
  components: {
    Select
  },
  props: {
    value: {
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    label: {
      type: String,
      default: '国家'
    }
  },
  computed: {
    options() {
      return this.list.map(item => ({
        label: item.name,
        value: item.id
      }));
    }
  },
  async created() {
    let res = await Api.get.getCountries();
    if (res.status === Codes.SUCCESS && res.data) {
      this.list = res.data;
    }
  },
  data: () => ({
    list: []
  }),
  methods: {
    handleInput(value) {
      this.$emit('input', value);
    }
  }
};
</script>
